var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.getUrlParam('type') === 'share' && _vm.getUrlParam('promoterId'))?_c('div',{staticClass:"invite-content"},[_c('img',{staticClass:"invite-icon",attrs:{"src":_vm.inviteIcon,"alt":"邀请有礼"},on:{"click":_vm.handletoRefer}})]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }